interface SearchProps {
  size?: number; // Optional size prop
}
export function Search({ size = 16 }: SearchProps) {
  return (
    <span className="anticon" style={{ fontSize: size }}>
      <i
        className="fa-solid fa-magnifying-glass"
        style={{ fontSize: size, color: '#ffffff' }}
        aria-hidden="true"
      />
    </span>
  );
}
